import googlePlay from "../../assets/google-play.svg";
import appStore from "../../assets/app-store.svg";
// import aboutImage from "../../assets/screens/5.png";
// import Iphone from "./Iphone";
import "./style.css";
import iphone from "../../assets/iphone.png";
import screen from "../../assets/screens/2.png";

const Download = () => {
	return (
		<div className="download" id="Download">
			<div className="container">
				<div className="row">
					<div className="col-lg-6 col-md-7">
						<p className="title">Download App Now</p>
						<p className="description">
							Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra
							nunc ante velit vitae. Est tellus vitae, nullam lobortis enim.
							Faucibus amet etiam tincidunt rhoncus, ullamcorper velit.
							Ullamcorper risus tempor, ac nunc libero urna, feugiat.
						</p>
						<div
							className="d-flex"
							style={{ gap: "25px", marginBottom: "24px" }}>
							<a
								href="https://play.google.com/store/apps/details?id=com.cloudsolution.padelink"
								target="_blank"
								rel="noreferrer">
								<img src={googlePlay} alt="googlePlay" />
							</a>
							<a
								href="https://apps.apple.com/us/app/padelink/id6752991798"
								target="_blank"
								rel="noreferrer">
								<img src={appStore} alt="appStore" />
							</a>
						</div>
						<div className="rating">
							<div className="rating-card">
								<svg
									width="36"
									height="35"
									viewBox="0 0 36 35"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_48_471)">
										<path
											d="M6.33334 27.7083H29.6667V17.5H32.5833V29.1667C32.5833 29.5534 32.4297 29.9244 32.1562 30.1979C31.8827 30.4714 31.5118 30.625 31.125 30.625H4.87501C4.48823 30.625 4.1173 30.4714 3.84381 30.1979C3.57032 29.9244 3.41667 29.5534 3.41667 29.1667V17.5H6.33334V27.7083ZM20.9167 13.125H28.2083L18 23.3333L7.79167 13.125H15.0833V4.375H20.9167V13.125Z"
											fill="#D80026"
										/>
									</g>
									<defs>
										<clipPath id="clip0_48_471">
											<rect
												width="35"
												height="35"
												fill="white"
												transform="translate(0.5)"
											/>
										</clipPath>
									</defs>
								</svg>
								<p className="fw-bold mb-0 mt-2">59865</p>
								<p className="mb-0">Download</p>
							</div>
							<div className="rating-card">
								<svg
									width="36"
									height="35"
									viewBox="0 0 36 35"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_48_477)">
										<path
											d="M3.41668 13.1252H7.79168V30.6252H3.41668C3.0299 30.6252 2.65897 30.4715 2.38548 30.198C2.11199 29.9245 1.95834 29.5536 1.95834 29.1668V14.5835C1.95834 14.1967 2.11199 13.8258 2.38548 13.5523C2.65897 13.2788 3.0299 13.1252 3.41668 13.1252ZM11.1356 11.2395L20.469 1.9062C20.593 1.7818 20.7578 1.70636 20.933 1.69377C21.1083 1.68118 21.2822 1.73227 21.4227 1.83766L22.6667 2.771C23.0122 3.03035 23.2731 3.3862 23.4166 3.79366C23.5602 4.20112 23.5798 4.64196 23.4731 5.06058L21.7917 11.6668H31.125C31.8986 11.6668 32.6404 11.9741 33.1874 12.5211C33.7344 13.0681 34.0417 13.8099 34.0417 14.5835V17.6518C34.0421 18.033 33.9678 18.4105 33.8229 18.7631L29.3094 29.7225C29.1993 29.9896 29.0123 30.2181 28.7721 30.3788C28.5319 30.5395 28.2494 30.6253 27.9604 30.6252H12.1667C11.7799 30.6252 11.409 30.4715 11.1355 30.198C10.862 29.9245 10.7083 29.5536 10.7083 29.1668V12.2706C10.7084 11.8838 10.8621 11.513 11.1356 11.2395Z"
											fill="#D80026"
										/>
									</g>
									<defs>
										<clipPath id="clip0_48_477">
											<rect
												width="35"
												height="35"
												fill="white"
												transform="translate(0.5)"
											/>
										</clipPath>
									</defs>
								</svg>

								<p className="fw-bold mb-0 mt-2">59865</p>
								<p className="mb-0">Like</p>
							</div>
							<div className="rating-card">
								<svg
									width="36"
									height="35"
									viewBox="0 0 36 35"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_48_486)">
										<path
											d="M18 26.629L7.71435 32.3865L10.0112 20.8248L1.35602 12.8215L13.0621 11.4332L18 0.729004L22.9379 11.4332L34.6439 12.8215L25.9887 20.8248L28.2856 32.3865L18 26.629Z"
											fill="#D80026"
										/>
									</g>
									<defs>
										<clipPath id="clip0_48_486">
											<rect
												width="35"
												height="35"
												fill="white"
												transform="translate(0.5)"
											/>
										</clipPath>
									</defs>
								</svg>
								<p className="fw-bold mb-0 mt-2">59865</p>
								<p className="mb-0">5 star rating</p>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-12 d-flex justify-content-center justify-center-mobile">
						<div className="phone-head">
							<div className="phone">
								<img src={iphone} className="iphone" alt="iphone" />
								<img src={screen} className="screen" alt="screen" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Download;
